import { FC } from 'react';
import { Tooltip, useTheme } from '@mui/material';
import { MdCheckCircle as CheckIcon } from 'react-icons/md';

const ConnectionEnabled: FC<React.PropsWithChildren<unknown>> = () => {
  const theme = useTheme();

  return (
    <Tooltip arrow title={'Connection enabled'}>
      <span style={{ fontSize: '1.25rem', display: 'inline-flex' }}>
        <CheckIcon color={theme.palette.success.main} fontSize='inherit' />
      </span>
    </Tooltip>
  );
};

export default ConnectionEnabled;
